
import { useState, useEffect } from 'react';

type ScrollPosition = {
  scrollY: number;
  scrollDirection: 'up' | 'down' | null;
  isScrolled: boolean;
};

export function useScrollPosition(threshold = 50): ScrollPosition {
  const [scrollPosition, setScrollPosition] = useState<ScrollPosition>({
    scrollY: 0,
    scrollDirection: null,
    isScrolled: false,
  });

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollPosition = () => {
      const scrollY = window.scrollY;
      const direction = scrollY > lastScrollY ? 'down' : 'up';
      const isScrolled = scrollY > threshold;
      
      setScrollPosition({
        scrollY,
        scrollDirection: direction,
        isScrolled,
      });
      
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener('scroll', updateScrollPosition, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', updateScrollPosition);
    };
  }, [threshold]);

  return scrollPosition;
}
